<template>
  <!-- 外发派车 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns" v-if="key!=2">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit">保存</el-button>
    </div>
    <!-- 基本信息 -->
    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form label-width="120px" class="glo_formBox">
          <el-form-item label="运单号:">
            <el-input v-model="sortingReq.waybillNumber" :disabled="key==2" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="分拣包装:">
            <el-input v-model="sortingReq.packageName" :disabled="key==2" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="分拣数量:">
            <el-input v-model="sortingReq.packageCount" :disabled="key==2" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="分拣费用:">
            <el-input v-model="sortingReq.amount" :disabled="key==2" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%;padding:16px 16px 16px 0;" label="分拣员:">
            <div class="setper" v-if="listShipper.length">
              <div class="s_tem" v-for="(item, index) in listShipper" :key="index">
                <span>{{item.objectName}}</span>
                <i v-if="key!=2" class="el-icon-error" @click="clickDel(index)"></i>
              </div>
            </div>
            <el-button v-if="key!=2" style="margin-top: 10px" size="small" class="glo_bgcMainColor" @click="addform">添加分拣员</el-button>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="sortingReq.remarks" :disabled="key==2"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="glo_Table">
      <el-table header-align="center" :data="consumablesReqs" border stripe :highlight-current-row="true">
        <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column align="center" label="耗材" prop="consumables"></el-table-column>
        <el-table-column label="数量" width="200">
          <template slot-scope="scope">
            <el-input :disabled="key==2" v-model="consumablesReqs[scope.$index].packageCount" placeholder="请输入" filterable></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" :sortable="false" v-if="key!=2">
          <template slot-scope="scope">
            <div class="iconList">
              <el-popconfirm title="确定删除该行信息吗" @confirm="delGoods(scope.$index)">
                <i slot="reference" class="el-icon-remove iconSize"></i>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="key!=2" style="margin-top: 10px" class="glo_bgcMainColor" @click="AddGoods">添加耗材</el-button>
    </div>

    <!-- 新增修改 -->
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable1" @row-click="rowclick1" :data="tableData1" border stripe @selection-change="handleSelectionChange1">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column align="center" label="耗材名称" prop="val"></el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 弹窗 收件人地址 -->
    <myDialog :diaWidth="diaWidth3" :dialogTitle="dialogTitle3" :isShowDialog="isShowDialog3" @handleCloseDia="handleCloseDia3" @diaCancelBtn="handleCloseDia3" @diaConfirmBtn="diaConfirmBtn3">
      <div class="glo_dialogForm">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form v-if="isShowDialog3" :model="queryData" class="glo_form" label-position="left">
            <el-form-item class="queryItems" label="姓名:">
              <el-input clearable v-model="queryData.name" placeholder="请输入" @keyup.enter.native="getCustomerAddrList()"></el-input>
            </el-form-item>
            <el-button class="glo_btnItems glo_bgcMainColor" @click="getCustomerAddrList">查询</el-button>
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe @selection-change="handleSelectionChange">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
  },
  data() {
    return {
      diaWidth1: "60%",
      dialogTitle1: "添加耗材",
      isShowDialog1: false,
      dialogForm1: {},
      tableData1: [],
      // 添加員工
      isShowDialog3: false,
      dialogTitle3: "添加员工",
      diaWidth3: "60%",
      tableData: [],
      addressTableHeard: [
        {
          name: "所属部门",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "工号",
        //   field: "number",
        //   width: "120",
        //   sort: 3,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "姓名",
          field: "employeeName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "手机号码",
          field: "phone",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], // 表格选择
      queryData: {
        // 查询条件
        name: "",
      },

      listShipper: [],
      sortingReq: {
        waybillNumber: "",
        amount: "",
        packageCount: "",
        packageName: "",
        remark: "",
        consumablesReqs: [],
        sortingUserReqs: [],
      },

      pageGroupName: "DispatchCar_OutgoingDispatch", //  页面标识
      reportFiledsNumber: "admin_waifa_dispatch_list", // 动态 条件、表头

      consumablesReqs: [],

      pathUrl: "/WarehouseManagement/PackagingSorting",
      key: 1,
    };
  },
  watch: {},
  created() {
    this.getConfDictValDownLists("material_bill");
  },
  mounted() {},
  activated() {
    let { pathUrl, waybillNumber, key } = this.$route.query || {};
    this.key = key || 1;
    this.pathUrl = pathUrl || "/WarehouseManagement/PackagingSorting";
    this.sortingReq = {};
    this.listShipper = [];
    this.consumablesReqs = [];
    if (waybillNumber) {
      this.sortingReq.waybillNumber = waybillNumber || "";
      this.$API.sortingOrderDetail({ waybillNumber }).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result || {};
          this.sortingReq = datas;
          this.listShipper = datas.sortingUserReqs || [];
          this.consumablesReqs = datas.consumablesReqs || [];
          this.sortingReq.waybillNumber = waybillNumber || "";
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    }
  },
  destroyed() {},
  methods: {
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //耗材
        if (val == "material_bill") {
          this.tableData1 = res || [];
        }
        console.log(this.tableData1);
      });
    },
    //货物信息 添加一行货物信息
    AddGoods() {
      this.isShowDialog1 = true;
    },
    //耗材 删除一行信息
    delGoods(idx) {
      this.consumablesReqs.splice(idx, 1);
    },
    addform(key) {
      this.isShowDialog3 = true;
      this.getCustomerAddrList();
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {};
    },
    //耗材 点击选中当前行
    rowclick1(row, event, column) {
      this.$refs.mytable1.toggleRowSelection(row);
    },
    //耗材 表格选择事件
    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    //耗材  弹窗确认保存事件
    diaConfirmBtn1() {
      if (this.selectTableData1.length < 1) {
        this.$message.error("请选择需要的数据");
        return false;
      }
      this.selectTableData1.forEach((element) => {
        this.consumablesReqs.push({
          consumables: element.val,
          packageCount: "",
        });
      });
      this.consumablesReqs = this.arrayFilter(
        this.consumablesReqs,
        "consumables"
      );

      this.isShowDialog1 = false;
    },
    //添加员工
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        name: "",
      };
    },
    //添加员工 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //添加员工 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //添加员工  弹窗确认保存事件
    diaConfirmBtn3() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要的数据");
        return false;
      }
      this.selectTableData.forEach((element) => {
        this.listShipper.push({
          objectNumber: element.employeeId,
          objectName: element.employeeName,
        });
      });
      this.listShipper = this.arrayFilter(this.listShipper, "objectNumber");
      this.isShowDialog3 = false;
    },
    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key]);
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index;
      });
    },
    //添加员工
    getCustomerAddrList() {
      this.$API
        .wtl_getEmployeeList({
          employeeName: this.queryData.name,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
        });
    },

    clickDel(index) {
      this.listShipper.splice(index, 1);
    },
    // 提交
    async submit() {
      this.consumablesReqs.forEach((n, i) => {
        n.sort = i;
      });
      this.sortingReq.consumablesReqs = this.consumablesReqs;
      this.listShipper.forEach((n, i) => {
        n.sort = i;
      });
      this.sortingReq.sortingUserReqs = this.listShipper;

      await this.$API.sortingOrder(this.sortingReq).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message || "操作成功");
          this.$TOOLS.closePage();
          this.$router.push({
            path: this.pathUrl,
            query: {
              isreload: "isreload",
            },
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 30px 10px;
}
.textArea {
  height: auto;
}
.setper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px;
  border: 1px dashed @borderColor;
  .s_tem {
    margin: 6px;
    .el-icon-error {
      cursor: pointer;
      color: red;
    }
  }
}
</style>
